import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';


export const getFamilyBasicInfoApi = ({
    efq,
    family_key_words,
    family_type,
    index,
    q,
    type,
    folder_id,
    space_id,
    qid,
    efqid,
    layer_id,
    field_id,
    ai_field_id,
    sort,
    bio_uk,
}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/family-database/view/basic-info`,
        method: 'POST',
        data: {
            efq,
            family_key_words,
            family_type,
            index,
            q,
            type,
            folder_id,
            space_id,
            qid,
            efqid,
            layer_id,
            field_id,
            ai_field_id,
            sort,
            bio_uk
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export const getFamilyPatentInfoApi = ({ patentId, q }) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/family-database/view/patent_id/${patentId}/patent-info`,
        method: 'POST',
        data: {
            q,
        },
        cache: true,
        uuid: patentId,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getFamilyPatentListApi = ({
    efq,
    family_count,
    family_id,
    family_keywords,
    family_type,
    hit_size,
    no_hit_size,
    page,
    patent_id,
    pn,
    q,
    type,
    patent_data,
    skip_no_hit,
    folder_id
}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/family-database/view/patent-list`,
        method: 'POST',
        data: {
            efq,
            family_count,
            family_id,
            family_keywords,
            family_type,
            hit_size,
            no_hit_size,
            page,
            patent_id,
            pn,
            q,
            type,
            patent_data,
            skip_no_hit,
            folder_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getFamilyPatentTimelineApi = ({ family_id, patent_id, family_type, page, rows }) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/family-database/view/timeline`,
        method: 'POST',
        data: { family_id, patent_id, family_type, page, rows },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
};
